/**
 * KPI Card Row - Premium KPI display with consistent card styling
 * Replaces inline period summary strip with premium card-based layout
 * Tooltips: use shared Tooltip component so hover/focus show visible tooltip content.
 */
import React from 'react';
import Tooltip from './Tooltip.jsx';

export default function KPICardRow({ kpis = [], isMobile = false, ...props }) {
  if (!kpis || kpis.length === 0) {
    return null;
  }

  return (
    <div className="owner-kpi-row" data-testid={props['data-testid'] || 'kpi-card-row'}>
      {kpis.map((kpi, index) => {
        const isEmptyValue = kpi.value === '—' || kpi.value === '—';
        const hasTooltip = kpi.tooltip && String(kpi.tooltip).trim().length > 0;

        return (
          <div
            key={index}
            className="owner-kpi-card"
            data-testid={kpi['data-testid'] || `kpi-card-${index}`}
          >
            <div className="owner-kpi-label">
              {kpi.label}
              {hasTooltip && !isMobile && (
                <Tooltip content={kpi.tooltip} asButton={true}>
                  <span className="owner-kpi-tooltip-icon" style={{ marginLeft: 'var(--spacing-1)', opacity: 0.8, fontSize: 'var(--font-size-xs)' }}>
                    ⓘ
                  </span>
                </Tooltip>
              )}
            </div>
            <div
              className="owner-kpi-value"
              style={isMobile && isEmptyValue ? { color: 'var(--color-text-secondary, #6b7280)' } : {}}
              data-empty={isMobile && isEmptyValue ? 'true' : undefined}
            >
              {kpi.value}
            </div>
            {kpi.delta && (
              <div style={{
                fontSize: 'var(--font-size-xs)',
                color: kpi.delta.isPositive ? 'var(--color-status-success-base)' : 'var(--color-status-warning-base)',
                marginTop: 'var(--spacing-1)',
              }}>
                {kpi.delta.isPositive ? '↑' : '↓'} {kpi.delta.value}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

